var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-wrapper"},[_c('b-container',[_c('PageContent',{attrs:{"usage":"footer"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }